module.exports = __webpack_public_path__ + "img/WD.c92bf88e.png";